/* eslint-disable no-tabs */
/* eslint-disable max-len */
import React from 'react';

export function DollarIcon() {
  return (
    <svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" width="23px" height="21px" viewBox="0 0 512 512" xmlSpace="preserve" data-iconid="483354" data-svgname="Three dollar banknotes">

      <g>
        <path
          style={{ fill: '#000000' }}
          d="M96.391,188.031v231.781H512V188.031H96.391z M120.375,343.234v-78.656
		c25.719-1.797,46.031-23.172,46.031-49.344c0-1.094-0.156-2.141-0.234-3.219h92.125c-25.578,18.828-42.641,52.906-42.641,91.906
		c0,38.984,17.063,73.094,42.641,91.922h-92.125c0.078-1.078,0.234-2.125,0.234-3.219
		C166.406,366.453,146.094,345.031,120.375,343.234z M282.203,348.344c-6.547-1.797-15.141-9.016-15.141-9.016
		c-0.719-0.438-1.203-1.188-1.313-2.031c-0.094-0.828,0.188-1.719,0.781-2.297l8.406-8.391c0.875-0.891,2.281-1.063,3.375-0.391
		c0,0,6.281,5.453,11.047,6.75c4.734,1.281,9.453,1.938,14.172,1.938c5.938,0,10.875-1.047,14.734-3.156
		c3.922-2.109,5.844-5.359,5.844-9.828c0-3.219-0.953-5.734-2.859-7.609c-1.938-1.844-5.172-3-9.75-3.531l-15.031-1.297
		c-8.875-0.844-15.75-3.297-20.563-7.391c-4.828-4.078-7.234-10.266-7.234-18.547c0-4.563,0.922-8.641,2.781-12.234
		c1.844-3.578,4.359-6.609,7.609-9.078c3.219-2.469,6.969-4.313,11.219-5.563c1.781-0.5,3.656-0.859,5.531-1.172v-12.063h16.75
		v11.844c3.906,0.375,7.625,1,11.063,1.953c5.875,1.609,12.063,6.422,12.063,6.422c0.766,0.391,1.297,1.141,1.438,2.016
		c0.125,0.844-0.156,1.719-0.781,2.344L328.484,276c-0.828,0.859-2.125,1.047-3.203,0.516c0,0-4.656-3.313-8.688-4.359
		c-4-1.063-8.25-1.563-12.688-1.563c-5.813,0-10.125,1.078-12.891,3.328c-2.766,2.203-4.172,5.125-4.172,8.688
		c0,3.25,0.984,5.703,2.969,7.438c1.969,1.719,5.313,2.844,10,3.313L313,294.5c9.766,0.875,17.125,3.453,22.125,7.781
		c5.031,4.313,7.531,10.625,7.531,18.906c0,4.953-1,9.281-2.969,12.953c-1.969,3.766-4.719,6.844-8.156,9.375
		c-3.469,2.563-7.609,4.438-12.422,5.688c-2.094,0.516-4.297,0.875-6.547,1.172v14.047h-16.75v-13.75
		C291.031,350.266,286.5,349.531,282.203,348.344z M350.094,212.016h92.094c-0.078,1.078-0.25,2.125-0.25,3.219
		c0,26.156,20.359,47.531,46.094,49.344v78.656c-25.734,1.797-46.094,23.219-46.094,49.391c0,1.094,0.172,2.141,0.25,3.219h-92.094
		c25.563-18.828,42.641-52.938,42.641-91.922C392.734,264.922,375.656,230.844,350.094,212.016z"
        />
        <polygon style={{ fill: '#000000' }} points="451.578,140.141 47.953,140.141 47.953,367.922 71.938,367.922 71.938,164.125 451.578,164.125 	" />
        <polygon style={{ fill: '#000000' }} points="379.656,92.188 0,92.188 0,303.984 23.969,303.984 23.969,116.156 379.656,116.156 	" />
      </g>
    </svg>
  );
}
